import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { products, categories } from '../data/products';

const levelColors = {
  1: { bg: '#f3f4f6', color: '#6b7280', label: 'Giriş / Ekonomik' },
  2: { bg: '#dcfce7', color: '#15803d', label: 'Standart Endüstriyel' },
  3: { bg: '#dbeafe', color: '#1d4ed8', label: 'Yüksek Performans' },
  4: { bg: '#fef2f2', color: '#dc2626', label: 'Premium / Özel Kesim' },
};

const ProductPage = () => {
  const { categoryId, productId } = useParams();
  const cat = products[categoryId];

  if (!cat) return <div style={{ padding: '10rem 2rem', textAlign: 'center' }}><h2>Kategori bulunamadı</h2><Link to="/" className="btn-primary">Ana Sayfa</Link></div>;

  let product = null;
  let groupLabel = '';
  for (const group of cat.groups) {
    const found = group.items.find(p => p.id === productId);
    if (found) { product = found; groupLabel = group.label; break; }
  }

  if (!product) return <div style={{ padding: '10rem 2rem', textAlign: 'center' }}><h2>Ürün bulunamadı</h2><Link to={`/urunler/${categoryId}`} className="btn-primary">Geri Dön</Link></div>;

  const lvl = levelColors[product.level] || levelColors[2];

  // Aynı kategorideki diğer ürünler
  const relatedGroup = cat.groups.find(g => g.items.some(p => p.id === productId));
  const related = relatedGroup ? relatedGroup.items.filter(p => p.id !== productId).slice(0, 4) : [];

  const whatsappLink = `https://wa.me/905470013478?text=Merhaba, sitenizdeki ${product.name} modeli hakkında fiyat ve stok bilgisi almak istiyorum.`;

  return (
    <div className="page-wrapper">
      <Helmet>
        <title>{product.name} | NetTest Endüstriyel Testere</title>
        <meta name="description" content={`${product.name}: ${product.tagline}. ${product.desc?.substring(0, 150)}...`} />
        <link rel="canonical" href={`https://nettesttestere.com/urunler/${categoryId}/${productId}`} />
      </Helmet>
      
      {/* Sayfa Başlığı */}
      <div className="page-hero">
        <div className="container">
          <div className="breadcrumb">
            <Link to="/">Anasayfa</Link>
            <span>/</span>
            <Link to={`/urunler/${categoryId}`}>{cat.title}</Link>
            <span>/</span>
            <span>{product.name}</span>
          </div>
          <h1>{product.name}</h1>
          <p>{product.tagline}</p>
        </div>
      </div>

      <div className="container page-layout">
        {/* SOL: Kategori Navigasyonu */}
        <aside className="page-sidebar">
          <div className="sticky-sidebar">
            <h4 className="sidebar-title">Kategoriler</h4>
            <ul className="sidebar-menu">
              {categories.map(c => (
                <li key={c.id}>
                  <Link
                    to={c.path}
                    className={`sidebar-link ${c.id === categoryId ? 'active' : ''}`}
                  >
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>

            {related.length > 0 && (
              <>
                <h4 className="sidebar-title" style={{ marginTop: '2rem' }}>İlgili Modeller</h4>
                <ul className="sidebar-menu">
                  {related.map(r => (
                    <li key={r.id}>
                      <Link to={`/urunler/${categoryId}/${r.id}`} className="sidebar-link">
                        {r.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </aside>

        {/* SAĞ: Ürün Detayı */}
        <main className="page-content">
          <div className="product-detail-card">
            {/* Başlık Alanı */}
            <div className="pd-header">
              <div className="pd-icon-box">
                <i className="fa-solid fa-gear"></i>
              </div>
              <div className="pd-title-area">
                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                  <h1 className="pd-name">{product.name}</h1>
                  <span className="pd-level-badge" style={{ background: lvl.bg, color: lvl.color, border: `1px solid ${lvl.color}` }}>
                    {lvl.label}
                  </span>
                </div>
                <p className="pd-tagline">{product.tagline}</p>
                <p style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: 600, textTransform: 'uppercase' }}>{groupLabel}</p>
              </div>
            </div>

            {/* Açıklama - SEO Optimize */}
            <div className="pd-section">
              <h2 className="pd-section-title">Ürün Detayı ve Kullanım Alanları</h2>
              <p className="pd-desc seo-desc">
                {product.desc}
                <br/><br/>
                Endüstriyel kesim işlemlerinde yüksek performans ve uzun bıçak ömrü arayan üreticiler için <strong>{product.name}</strong>, kesim maliyetlerini düşürmek ve verimliliği artırmak üzere tasarlanmıştır. 
              </p>
            </div>

            {/* Teknik Özellikler Tablosu */}
            <div className="pd-section">
              <h2 className="pd-section-title">Teknik Spesifikasyonlar</h2>
              <div className="pd-specs-table">
                {product.specs.map((s, i) => (
                  <div className={`pd-spec-row ${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                    <span className="pd-spec-label"><i className="fa-solid fa-chevron-right" style={{fontSize:'0.7rem', marginRight:'8px', color:'var(--primary)'}}></i> {s.label}</span>
                    <span className="pd-spec-value">{s.value}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Avantajlar */}
            {product.advantages && (
              <div className="pd-section">
                <h2 className="pd-section-title">Öne Çıkan Avantajlar</h2>
                <ul className="pd-advantages grid-advantages">
                  {product.advantages.map((a, i) => (
                    <li key={i}>
                      <i className="fa-solid fa-circle-check"></i>
                      <span>{a}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Sabit Teklif Butonu Alanı */}
            <div className="sticky-cta-bar">
              <div className="cta-text">
                <strong>{product.name}</strong>
                <span>Toplu alımlarda veya özel kesim ölçüleriniz için fiyat isteyin.</span>
              </div>
              <div className="cta-buttons">
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="btn-primary whatsapp-btn">
                  <i className="fa-brands fa-whatsapp"></i>
                  Fiyat ve Teklif Al
                </a>
                <Link to={`/urunler/${categoryId}`} className="btn-outline">
                  <i className="fa-solid fa-arrow-left"></i>
                  Geri
                </Link>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ProductPage;
